/** @jsx h */
import { h } from 'preact';

/** Outline X icon. */
export function CloseIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
      <rect x="-0.0430065" y="12.6373" width="17.9335" height="1.41755" rx="0.708777" transform="rotate(-45 -0.0430065 12.6373)" fill="currentColor" stroke="currentColor" stroke-width="0.5"/>
      <rect x="12.6377" y="13.6402" width="17.9335" height="1.41755" rx="0.708777" transform="rotate(-135 12.6377 13.6402)" fill="currentColor" stroke="currentColor" stroke-width="0.5"/>
    </svg>
  );
}

/** Outline pencil icon. */
export function PencilIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M14.5995 0.265945C14.2449 -0.0886485 13.6705 -0.0886485 13.3171 0.265945L0.907452 12.6754C0.762069 12.8208 0.668694 13.0111 0.647416 13.2167L0.00560328 18.993C-0.0251273 19.2684 0.071794 19.5402 0.265639 19.7341C0.438206 19.9066 0.667502 20 0.907452 20C0.940549 20 0.973642 19.9965 1.00674 19.9941L6.78308 19.3523C6.98875 19.3286 7.17905 19.2376 7.32444 19.0923L19.7341 6.68283C19.9031 6.51381 20 6.28097 20 6.04103C20 5.80227 19.9031 5.56942 19.7341 5.39922L14.5995 0.265945ZM6.68389 17.169L2.83198 13.3171L11.38 4.76925L15.2319 8.6211L6.68389 17.169ZM2.24194 15.2921L4.70517 17.7552L1.93343 18.0637L2.24194 15.2921ZM16.5179 7.3351L12.666 3.48325L13.9579 2.19139L17.8098 6.04323L16.5179 7.3351Z" fill="currentColor"/>
    </svg>
  );
}

/** Check / tick icon. */
export function CheckIcon() {
  return (
    <svg width="19" height="15" viewBox="0 0 19 15" fill="none">
      <path d="M15.9146 0.706421L7.01768 10.3398L2.26674 6.26708L0.704102 8.09538L6.34976 12.9373L7.23189 13.7064L8.02583 12.849L17.7041 2.35819L15.9146 0.706421Z" fill="currentColor" stroke="currentColor"/>
    </svg>
  );
}

export function ArrowUpIcon() {
  return (
    <svg width="19" height="23" viewBox="0 0 19 23" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.66616 0.353559C9.1465 -0.126781 9.87261 -0.10368 10.2774 0.337868L10.2847 0.345877L18.6257 8.68689C19.1061 9.16723 19.083 9.89334 18.6414 10.2981L18.6334 10.3054L18.6257 10.3131C18.3798 10.559 18.1158 10.6667 17.8126 10.6667C17.5094 10.6667 17.2454 10.559 16.9995 10.3131L10.6459 3.95957V21.1667C10.6459 21.835 10.1476 22.3333 9.47928 22.3333C8.81097 22.3333 8.31261 21.835 8.31261 21.1667V3.95957L1.95906 10.3131C1.47872 10.7935 0.752608 10.7704 0.347855 10.3288C-0.115902 9.82289 -0.105645 9.08947 0.31714 8.70192L0.325149 8.69457L8.66616 0.353559Z" fill="currentColor"/>
    </svg>
  );
}

export function MinusIcon() {
  return (
    <svg width="19" height="2" viewBox="0 0 19 2" fill="none">
      <rect opacity="0.25" x="0.0999512" y="0.100012" width="18.4143" height="1.2" fill="black" stroke="black" stroke-width="0.2"/>
    </svg>
  );
}

export function PlusIcon() {
  return (
    <svg width="19" height="18" viewBox="0 0 19 18" fill="none">
      <g opacity="0.25">
        <mask id="path-1-outside-1_3575_25466" maskUnits="userSpaceOnUse" x="-0.799805" y="-0.799988" width="20" height="19" fill="black">
          <rect fill="white" x="-0.799805" y="-0.799988" width="20" height="19"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M9.84326 8.20001V0.200012H8.77183V8.20001H0.200195V9.20001H8.77183V17.2H9.84326V9.20001H18.4145V8.20001H9.84326Z"/>
        </mask>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.84326 8.20001V0.200012H8.77183V8.20001H0.200195V9.20001H8.77183V17.2H9.84326V9.20001H18.4145V8.20001H9.84326Z" fill="black"/>
        <path d="M9.84326 0.200012H10.0433V1.22041e-05H9.84326V0.200012ZM9.84326 8.20001H9.64326V8.40001H9.84326V8.20001ZM8.77183 0.200012V1.22041e-05H8.57183V0.200012H8.77183ZM8.77183 8.20001V8.40001H8.97183V8.20001H8.77183ZM0.200195 8.20001V8.00001H0.00019531V8.20001H0.200195ZM0.200195 9.20001H0.00019531V9.40001H0.200195V9.20001ZM8.77183 9.20001H8.97183V9.00001H8.77183V9.20001ZM8.77183 17.2H8.57183V17.4H8.77183V17.2ZM9.84326 17.2V17.4H10.0433V17.2H9.84326ZM9.84326 9.20001V9.00001H9.64326V9.20001H9.84326ZM18.4145 9.20001V9.40001H18.6145V9.20001H18.4145ZM18.4145 8.20001H18.6145V8.00001H18.4145V8.20001ZM9.64326 0.200012V8.20001H10.0433V0.200012H9.64326ZM8.77183 0.400012H9.84326V1.22041e-05H8.77183V0.400012ZM8.97183 8.20001V0.200012H8.57183V8.20001H8.97183ZM0.200195 8.40001H8.77183V8.00001H0.200195V8.40001ZM0.400195 9.20001V8.20001H0.00019531V9.20001H0.400195ZM8.77183 9.00001H0.200195V9.40001H8.77183V9.00001ZM8.97183 17.2V9.20001H8.57183V17.2H8.97183ZM9.84326 17H8.77183V17.4H9.84326V17ZM9.64326 9.20001V17.2H10.0433V9.20001H9.64326ZM18.4145 9.00001H9.84326V9.40001H18.4145V9.00001ZM18.2145 8.20001V9.20001H18.6145V8.20001H18.2145ZM9.84326 8.40001H18.4145V8.00001H9.84326V8.40001Z" fill="black" mask="url(#path-1-outside-1_3575_25466)"/>
      </g>
    </svg>

  );
}

export function StockIcon() {
  return (
    <svg width="15" height="12" viewBox="0 0 15 12" fill="none">
      <path d="M13.1338 0L5.45159 8.31338L1.34929 4.79871L0 6.37649L4.87486 10.5549L5.63656 11.2187L6.3221 10.4788L14.679 1.42544L13.1338 0Z" fill="currentColor"/>
    </svg>
  );
}

export function OutOfStockIcon() {
  return (
    <svg width="11" height="11" viewBox="0 0 11 11" fill="none">
      <path d="M9.72093 0L5.5 4.22094L1.27907 0L0 1.27908L4.22093 5.49999L0 9.72091L1.27907 11L5.5 6.77907L9.72093 11L11 9.72091L6.77907 5.49999L11 1.27908L9.72093 0Z" fill="currentColor"/>
    </svg>
  );
}

export function ArrowBackIcon() {
  return (
    <svg width="7" height="12" viewBox="0 0 7 12" fill="none">
      <path d="M5.37109 0.295898C5.60088 0.068025 5.97251 0.0678799 6.20215 0.295898C6.43213 0.52461 6.43272 0.896411 6.20215 1.125L1.5459 5.75L6.20215 10.375C6.43246 10.6038 6.43257 10.9754 6.20215 11.2041C6.0871 11.3182 5.93615 11.375 5.78613 11.375C5.63593 11.375 5.48512 11.3181 5.37012 11.2041L0.297852 6.16406C0.187377 6.05431 0.125031 5.90565 0.125 5.75C0.125 5.59419 0.187708 5.44559 0.297852 5.33594L5.37109 0.295898Z" fill="currentColor" stroke="currentColor" stroke-width="0.25"/>
    </svg>
  );
}

export function SaveIcon() {
  return (
    <svg width="24" height="19" viewBox="0 0 24 19" fill="none">
      <path d="M20.3848 0.710144L8.8712 13.3076L2.72292 7.98177L0.700684 10.3726L8.00683 16.7044L9.14841 17.7101L10.1759 16.5889L22.7007 2.87015L20.3848 0.710144Z" fill="currentColor" stroke="none"/>
    </svg>
  );
}